<section id="obj-handler">
    <div *ngIf="showBack"  class="d-flex justify-content-between my-1 py-1 sticky-top" style="min-height: 40px; background: #fcf8fb;">
        <div>
            <button mat-icon-button (click)="navBack()">
                <mat-icon>keyboard_backspace</mat-icon>
            </button>
        </div>
        <div style="align-self: center;">
            <div style="align-self: center;" *ngIf="formTitle | async as title">{{title}}</div>
        </div>
        <div></div>
    </div>
    <ng-template injectComp></ng-template>
</section>
